/* NewsletterSignupV2SuccessfulTemplate */
import { FunctionalComponent, h } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { NewsletterSignupV2Component } from '../newsletter-signup-v2';

/**
 * Definition of  parameters that the template needs to work.
 */
interface NewsletterSignupV2SuccesfulTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: NewsletterSignupV2Component;
  // Specify parameters that are required to be passed down to the template here.
}

const NewsletterSignupV2SuccessfulTemplate: FunctionalComponent<NewsletterSignupV2SuccesfulTemplateProps> = ({
  controller,
}) => (
  <cwc-newsletter-signup-main>
    <slot name="successful-illustration" />
    {controller.successfulHeadline ? (
      <cwc-newsletter-signup-headline>
        <slot name="successful-headline" />
      </cwc-newsletter-signup-headline>
    ) : (
      ''
    )}
    {controller.successfulSubheadline ? (
      <cwc-newsletter-signup-subheadline>
        <slot name="successful-subheadline" />
      </cwc-newsletter-signup-subheadline>
    ) : (
      ''
    )}
    {controller.successfulText ? (
      <cwc-newsletter-signup-text>
        <slot name="successful-text" />
      </cwc-newsletter-signup-text>
    ) : (
      ''
    )}
  </cwc-newsletter-signup-main>
);

export default NewsletterSignupV2SuccessfulTemplate;
